/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaOverlayHeader/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaOverlayHeader({
  children,
  viewPath = "/DesignSystem/TysiaOverlay/TysiaOverlayHeader",
  height = "52px",
  backgroundColor,
  borderBottomWidth = 1,
  borderBottomStyle = "solid",
  borderBottomColor,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  width = "100%",
  alignItems = "center",
  justifyContent = "space-between"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderBottomColorOrdtColorsNeutral200 = borderBottomColor ?? dtColorsNeutral200
let paddingLeftOrdtSpaceS = paddingLeft ?? dtSpaceS
let paddingRightOrdtSpaceS = paddingRight ?? dtSpaceS
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
let paddingBottomOrdtSpaceS = paddingBottom ?? dtSpaceS
  return (<React.Fragment
>
<div
  data-testid="TysiaOverlayHeader.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-2sW0VG': typeof height === 'number' ? `${height}px` : height,'--bc-2-2sW0VG': backgroundColorOrdtColorsWhite,'--bbw-3-2sW0VG': typeof borderBottomWidth === 'number' ? `${borderBottomWidth}px` : borderBottomWidth,'--bbs-4-2sW0VG': borderBottomStyle,'--bbc-5-2sW0VG': borderBottomColorOrdtColorsNeutral200,'--pl-6-2sW0VG': typeof paddingLeftOrdtSpaceS === 'number' ? `${paddingLeftOrdtSpaceS}px` : paddingLeftOrdtSpaceS,'--pr-7-2sW0VG': typeof paddingRightOrdtSpaceS === 'number' ? `${paddingRightOrdtSpaceS}px` : paddingRightOrdtSpaceS,'--pt-8-2sW0VG': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--pb-9-2sW0VG': typeof paddingBottomOrdtSpaceS === 'number' ? `${paddingBottomOrdtSpaceS}px` : paddingBottomOrdtSpaceS,'--w-10-2sW0VG': typeof width === 'number' ? `${width}px` : width,'--ai-11-2sW0VG': alignItems,'--jc-12-2sW0VG': justifyContent}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}